// src/modules/app-views/_apps/appmulti/receivables/pages/Document/cardHeaderItems.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import {
  CalendarOutlined,
  CheckCircleOutlined,
  LinkOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { BsCashCoin } from 'react-icons/bs';
import { FiShoppingBag } from 'react-icons/fi';
import dayjs from 'dayjs';
import translateX from 'utils/translateX';
import financialService from 'services/financialService';

// *******************************************************************************
// ITEMS
// *******************************************************************************
export const receivableStatusItem = record => {
  const status = record?.__statusView || record?.status;
  return {
    key: 'receivableStatus',
    icon: <CheckCircleOutlined />,
    label: status ? translateX(status) : null,
    tooltipText: translateX('status'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const receivableValueItem = record => {
  if (record?.value == null) return { key: 'receivableValue', label: null };
  const formatted = financialService.formatNumber(record.value, { decimals: 2, locale: 'pt-BR' });
  return {
    key: 'receivableValue',
    icon: <BsCashCoin />,
    label: `R$ ${formatted}`,
    tooltipText: translateX('value'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const receivableDueDateItem = record => {
  if (!record?.dueDate) return { key: 'receivableDueDate', label: null };
  return {
    key: 'receivableDueDate',
    icon: <CalendarOutlined />,
    label: dayjs(record.dueDate).format('L'),
    tooltipText: translateX('due_date'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const receivableOrderItem = record => {
  if (!record?.order) return { key: 'receivableOrder', label: null };
  return {
    key: 'receivableOrder',
    icon: <FiShoppingBag />,
    label: String(record.order),
    tooltipText: translateX('order'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const receivableCustomerItem = record => {
  const name = record?.__customer?.name || record?.__customer?.fullName;
  return {
    key: 'receivableCustomer',
    icon: <UserOutlined />,
    label: name || null,
    tooltipText: translateX('customer'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const receivablePaymentLinkItem = record => {
  const url = record?.paymentUrl;
  if (!url) return { key: 'receivablePaymentLink', label: null };
  return {
    key: 'receivablePaymentLink',
    icon: <LinkOutlined />,
    label: translateX('view_billing'),
    tooltipText: translateX('payment_link'),
    tooltipPlacement: 'right',
    onClick: () => window.open(url, '_blank'),
  };
};
